import React, { useMemo } from 'react'
import { Drawer, Divider, Skeleton, Collapse } from 'antd'
import { HistoryItem } from './HistoryItem'
import { NothingMessage, Horizontal, Vertical, Texto } from '@gravitate-js/excalibrr'
import { formatters } from '@utils/intl/dateTimeFormatters'
import { useOrders } from '@api/useOrders'
import { InferResponse } from '@/hooks/useApiClient'
const { Panel } = Collapse
export const UpdateHistoryDrawer = ({ selectedOrderId, closeAuditDrawer }) => {
  const { useAuditHistoryQuery } = useOrders()
  const { data: auditHistoryData, isLoading } = useAuditHistoryQuery(selectedOrderId)
  const auditHistory = useMemo(() => auditHistoryData?.reverse(), [auditHistoryData, selectedOrderId])

  return (
    <>
      {selectedOrderId && auditHistory && (
        <Drawer
          title={auditHistory ? ` Order ${auditHistory[0]?.extra_data.number} Audit` : `No Audit History`}
          placement='right'
          closable
          onClose={closeAuditDrawer}
          open={!!selectedOrderId}
          key='right'
          width='600'
          rootStyle={{
            height: '100%',
            overflowY: 'scroll',
          }}
        >
          <Content auditHistory={auditHistory} loading={isLoading} />
        </Drawer>
      )}
    </>
  )
}

export type ContentProps = {
  auditHistory: { action: string }[]
  loading: boolean
}

export const Content = ({ auditHistory, loading }: ContentProps) => {
  if (loading) return <Skeleton active avatar paragraph={{ rows: 4 }} />
  return (
    <>
      {auditHistory?.length ? (
        auditHistory.map((action, index) => {
          if (action.action === 'batch') {
            return <BatchUpdate batch={action} />
          }
          return (
            <div key={index}>
              {index !== 0 && <Divider type='vertical' style={{ height: '50px' }} />}
              <HistoryItem action={action} />
            </div>
          )
        })
      ) : (
        <NothingMessage
          className='audit-no-data'
          title='No Audit History Exists'
          message='Future changes can be viewed here'
        />
      )}
    </>
  )
}
export const BatchUpdate = ({ batch, title, key }) => {
  if (!title) {
    title = batch.extra_data.title
  }
  const { actions } = batch.extra_data
  const { date } = batch
  return (
    <>
      <Collapse defaultActiveKey={['1']} bordered={false}>
        <Panel
          className='custom-collapse-header'
          header={
            <Horizontal background='bg-2' verticalCenter flex={1}>
              <Vertical>
                <Texto style={{ textTransform: 'capitalize' }} category='h5'>
                  {title}
                </Texto>
              </Vertical>
              <Vertical alignItems='flex-end'>
                <Texto>{formatters.SHORT_DATE_TIME(new Date(date))}</Texto>
              </Vertical>
            </Horizontal>
          }
          key={key ?? '1'}
        >
          {actions &&
            actions.map((action, i) => (
              <div key={i}>
                {i !== 0 && <Divider type='vertical' style={{ height: '50px' }} />}
                <HistoryItem action={action} />
              </div>
            ))}
          {!actions && (
            <div className='bg-1 p-2' style={{ marginLeft: '0' }}>
              <HistoryItem action={batch} />
            </div>
          )}
        </Panel>
      </Collapse>
    </>
  )
}
